module.exports = __webpack_public_path__ + "static/media/icn_satisfied_clients.53c4cd2c.svg";